import "./FormStyles.css";
import React, { useState } from "react";
import { FaLinkedin } from "react-icons/fa";
import emailjs from '@emailjs/browser';

const Form = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
    honeypot: "", // Campo invisible para detectar bots
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [formStartTime, setFormStartTime] = useState(null);

  // Inicializar tiempo cuando se monta el componente
  React.useEffect(() => {
    setFormStartTime(Date.now());
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);
    
    // Validaciones de seguridad anti-spam
    const currentTime = Date.now();
    const timeSpent = (currentTime - formStartTime) / 1000; // en segundos
    
    // Verificar honeypot - si está lleno, es un bot
    if (formData.honeypot !== "") {
      console.log("Bot detectado - honeypot lleno");
      setSubmitStatus('error');
      setIsSubmitting(false);
      setTimeout(() => setSubmitStatus(null), 5000);
      return;
    }
    
    // Verificar tiempo mínimo (al menos 5 segundos)
    if (timeSpent < 5) {
      setSubmitStatus('error');
      setIsSubmitting(false);
      setTimeout(() => setSubmitStatus(null), 5000);
      return;
    }
    
    // Verificar longitud mínima del mensaje
    if (formData.message.length < 10) {
      setSubmitStatus('message_too_short');
      setIsSubmitting(false);
      setTimeout(() => setSubmitStatus(null), 5000);
      return;
    }
    
    // Verificar patrones de spam en el mensaje
    const spamPatterns = [
      /http[s]?:\/\/[^\s]+/gi, // URLs
      /[A-Z]{5,}/g, // Palabras en mayúsculas largas
      /(.)\1{4,}/g, // Caracteres repetidos
      /\b(viagra|casino|loan|free money|click here)\b/gi // Palabras spam comunes
    ];
    
    if (spamPatterns.some(pattern => pattern.test(formData.message))) {
      setSubmitStatus('spam_detected');
      setIsSubmitting(false);
      setTimeout(() => setSubmitStatus(null), 5000);
      return;
    }
    
    // Configuración de EmailJS
    const SERVICE_ID = 'service_j9waulo';
    const TEMPLATE_ID = 'template_j2junmz';
    const PUBLIC_KEY = 'G4pO4yM09qu8e-OFu';
    
    // Parámetros del template para EmailJS
    const templateParams = {
      from_name: formData.name,
      from_email: formData.email,
      subject: formData.subject,
      message: formData.message,
      to_email: 'mbozzoletti@hotmail.com'
    };

    try {
      const response = await emailjs.send(
        SERVICE_ID,
        TEMPLATE_ID,
        templateParams,
        PUBLIC_KEY
      );
      
      console.log('Email enviado exitosamente:', response);
      setSubmitStatus('success');
      setFormData({ name: "", email: "", subject: "", message: "", honeypot: "" });
      setFormStartTime(Date.now()); // Reiniciar tiempo
      
      // Resetear estado después de 5 segundos
      setTimeout(() => setSubmitStatus(null), 5000);
    } catch (error) {
      console.error('Error al enviar el email:', error);
      setSubmitStatus('error');
      
      // Resetear estado de error después de 5 segundos
      setTimeout(() => setSubmitStatus(null), 5000);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-container">
      <div className="contact-content">
        <div className="contact-header">
          <h1>Get In Touch</h1>
          <p>Let's work together on your next project</p>
        </div>

        <div className="contact-info">
          <div className="info-item">
            <div className="info-icon">📧</div>
            <div className="info-content">
              <h3>Email</h3>
              <p>mbozzoletti@hotmail.com</p>
            </div>
          </div>
          
          <div className="info-item">
            <div className="info-icon">
              <FaLinkedin />
            </div>
            <div className="info-content">
              <h3>LinkedIn</h3>
              <a 
                href="https://www.linkedin.com/in/mariano-bozzoletti/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="linkedin-link"
              >
                Mariano Bozzoletti
              </a>
            </div>
          </div>
        </div>

        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Your full name"
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="your.email@example.com"
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="subject">Subject</label>
            <input
              type="text"
              id="subject"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              required
              placeholder="What's this about?"
            />
          </div>

          <div className="form-group">
            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              rows="6"
              placeholder="Tell me about your project..."
              minLength="10"
            />
           
          </div>

          {/* Campo honeypot invisible para detectar bots */}
          <div className="honeypot-field">
            <label htmlFor="website">Website (leave empty)</label>
            <input
              type="text"
              id="website"
              name="honeypot"
              value={formData.honeypot}
              onChange={handleChange}
              tabIndex="-1"
              autoComplete="off"
            />
          </div>

          <button 
            type="submit" 
            className={`submit-btn ${isSubmitting ? 'submitting' : ''}`}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Sending...' : 'Send Message'}
          </button>

          {submitStatus === 'success' && (
            <div className="success-message">
              <span>✓</span> ¡Mensaje enviado exitosamente!
            </div>
          )}

          {submitStatus === 'error' && (
            <div className="error-message">
              <span>✕</span> Error al enviar el mensaje. Por favor, intenta de nuevo.
            </div>
          )}

          {submitStatus === 'message_too_short' && (
            <div className="error-message">
              <span>✕</span> El mensaje debe tener al menos 10 caracteres.
            </div>
          )}

          {submitStatus === 'spam_detected' && (
            <div className="error-message">
              <span>✕</span> El mensaje contiene contenido no permitido.
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default Form;
